import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnlockYourInvestmentPotential from "./sections/UnlockYourInvestmentPotential";
import WhyChooseGenesisInversores from "./sections/WhyChooseGenesisInversores";
import OurSpecializedCourses from "./sections/OurSpecializedCourses";
import InvestmentStrategies from "./sections/InvestmentStrategies";
import AdvancedToolsWeTeach from "./sections/AdvancedToolsWeTeach";
import StudentSuccessStories from "./sections/StudentSuccessStories";
import EjemplosDeExitoDeNuestrasOperacionesEnInversiones from "./sections/EjemplosDeExitoDeNuestrasOperacionesEnInversiones";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
import BlackButton from "./sections/BlackButton";
export default function HomePage() {
  return <div>
      <Header />
      <UnlockYourInvestmentPotential />
      <WhyChooseGenesisInversores />
      <OurSpecializedCourses />
      <InvestmentStrategies />
      <AdvancedToolsWeTeach />
      <StudentSuccessStories />
      <EjemplosDeExitoDeNuestrasOperacionesEnInversiones />
      <FrequentlyAskedQuestions />
      <BlackButton />
      <Footer />
    </div>;
}